import { render, staticRenderFns } from "./DoorGlass.vue?vue&type=template&id=3ee5f152&scoped=true"
import script from "./DoorGlass.vue?vue&type=script&lang=ts"
export * from "./DoorGlass.vue?vue&type=script&lang=ts"
import style0 from "./DoorGlass.vue?vue&type=style&index=0&id=3ee5f152&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee5f152",
  null
  
)

export default component.exports